/**
 * Pledge Service
 *
 * Handles API calls for recording and managing donor pledges.
 */

import { getApiClient } from './client';

export interface PledgeCreatePayload {
  companyId: number;
  pledgeBy: string;
  pledgeEmail?: string | null;
  pledgePhoneNumber?: string | null;
  pledgeDonationType?: number | null;
  amountPledged?: number | null;
  datePledged: string; // ISO datetime string
  donorId?: number | null;
  statusCode?: number;
}

export interface Pledge {
  pledgeRecordId: number;
  companyId: number;
  donorId: number | null;
  reviewDonorId: number | null;
  pledgeBy: string;
  pledgeEmail: string | null;
  pledgePhoneNumber: string | null;
  pledgeDonationType: number | null;
  pledgeDonationTypeDescription: string | null;
  amountPledged: number | null;
  datePledged: string;
  dateConfirmed: string | null;
  statusCode: number | null;
  createdBy: number | null;
  createdDate: string | null;
  modifiedBy: number | null;
  modifiedDate: string | null;
}

export interface PledgeListResponse {
  count: number;
  items: Pledge[];
  status: string;
}

export interface PledgeSingleResponse {
  item: Pledge;
  status: string;
}

export interface GetPledgesOptions {
  donorId?: number;
  statusCode?: number;
  pledgeDonationType?: number;
  dateFrom?: string;
  dateTo?: string;
}

/**
 * Get pledges for a company with optional filters
 */
export async function getPledges(
  companyId: number,
  options: GetPledgesOptions = {}
): Promise<PledgeListResponse> {
  const apiClient = getApiClient();
  const params = new URLSearchParams();
  //if (options.donorId !== undefined) params.set('donor_id', String(options.donorId));
  if (options.statusCode !== undefined) params.set('status_code', String(options.statusCode));
  if (options.pledgeDonationType !== undefined)
    params.set('pledge_donation_type', String(options.pledgeDonationType));
  if (options.dateFrom) params.set('date_from', options.dateFrom);
  if (options.dateTo) params.set('date_to', options.dateTo);

  const qs = params.toString();
  const response = await apiClient.get<PledgeListResponse>(
    `/pledges/${companyId}${qs ? `?${qs}` : ''}`
  );
  return response.data;
}

/**
 * Create a new pledge
 */
export async function createPledge(payload: PledgeCreatePayload): Promise<PledgeSingleResponse> {
  const apiClient = getApiClient();
  const response = await apiClient.post<PledgeSingleResponse>('/pledges', payload);
  return response.data;
}
